import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './aadConfig';

export const msalInstance = new PublicClientApplication(msalConfig);
